<template>
  <div id="user-roles">
    <header class="row mb-2">
      <div class="col-sm-9">
        <slot></slot>
      </div>
      <div class="text-sm-right col-sm-3">
        <BButton v-if="!readOnly" :disabled="disabled" class="pull-right" size="sm" variant="light" @click="select">
          <font-awesome-icon icon="plus"></font-awesome-icon>
        </BButton>
      </div>
    </header>

    <p v-if="data && data.length === 0" class="text-center mt-4">{{ $t("formList.nothingToShow") }}</p>
    <BListGroup v-else>
      <BListGroupItem
        v-for="item in data"
        :key="item['id'] ?? undefined"
        class="d-flex justify-content-between align-items-center"
      >
        <slot name="itemTemplate" v-bind:item="item">{{ item == undefined ? undefined : item[textField] }} </slot>
        <BButton v-if="!readOnly" size="sm" variant="outline-light" @click="remove(item?.[idField ?? 0])">
          <font-awesome-icon icon="minus"></font-awesome-icon>
        </BButton>
      </BListGroupItem>
    </BListGroup>
  </div>
  <!-- /#user-roles -->
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { BButton, BListGroup, BListGroupItem } from "bootstrap-vue-next";

export default defineComponent({
  name: "FormList",
  components: {
    BButton,
    BListGroupItem,
    BListGroup
  },
  props: {
    disabled: {
      type: Boolean
    },
    data: {
      type: Array as () => any[]
    },
    idField: {
      type: String,
      default: "id"
    },
    textField: {
      type: String,
      default: "name"
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ["selected", "removed"],
  methods: {
    select() {
      this.$emit("selected");
    },
    remove(id: string) {
      this.$emit("removed", { id: id });
    }
  }
});
</script>
